/**
 * The hb-create-new-panel
 *
 * This directive shows the create new options: new project, new client, new invoice in randomized order.
 *
 * parameters:
 * base-css-class-name : the class name to be nested for both ul and li
 * on-before-item-click : function to be called before any item click
 * on-before-create-invoice-click: function to be called before create new invoice click
 * is-tile-mode: Boolean. display mode of tiles rather than a list
 * is-mobile: Boolean. is mobile.
 *
 */

(function () {
    'use strict';

    Directives.CreateNewPanel = function CreateNewPanel() {

        // @ngInject
        function CreateNewPanelControllerConstructor($scope, $injector, UiPersistenceService, _, EventService, ModalService, WorkspaceService, UsersManager, UserService, $timeout, Enums, $rootScope, NavigationService, AppStates) {
            this.constructor.$super.call(this, $scope, $injector);
            this._objectType = 'CreateNewPanelController';
            this.UiPersistenceService = UiPersistenceService;
            this._ = _;
            this.EventService = EventService;
            this.ModalService = ModalService;
            this.WorkspaceService = WorkspaceService;
            this.UserService = UserService;
            this.UsersManager = UsersManager;
            this.$timeout = $timeout;
            this.$rootScope = $rootScope;
            this.Enums = Enums;
            this.currUser = this.UsersManager.getCurrUser();
            this.NavigationService = NavigationService;
            this.AppStates = AppStates;

            // + new options list
            this.options = [{
                key: this.Enums.createNew.project,
                order: 0,
                translationKey: this.isTileMode
                  ? "MAIN_NAV.CREATE_MENU._PROJECT_"
                  : "MAIN_NAV.CREATE_MENU._NEW_PROJECT_",
                onClick: this.createEvent.bind(this),
                iconCssClass: this.isTileMode
                  ? this.baseCssClassName + "__create-menu__option-icon--project"
                  : this.baseCssClassName + "__create-menu__option-icon icon-hb-nx-briefcase",
                analyticsEvent: "create project",
                analyticsProps: "source: create menu"
            }, {
                key: this.Enums.createNew.client,
                order: 0,
                translationKey: this.isTileMode
                                    ? "MAIN_NAV.CREATE_MENU._CLIENT_"
                                    : "MAIN_NAV.CREATE_MENU._NEW_CLIENT_",
                onClick: this.onCreateClientClicked.bind(this),
                iconCssClass: this.isTileMode
                                    ? this.baseCssClassName + "__create-menu__option-icon--client"
                                    : this.baseCssClassName + "__create-menu__option-icon icon-hb-nx-user",
                analyticsEvent: "create client",
                analyticsProps: "source: create menu"
            }, {
                key: this.Enums.createNew.invoice,
                order: 0,
                translationKey: this.isTileMode
                                    ? "MAIN_NAV.CREATE_MENU._INVOICE_"
                                    : "MAIN_NAV.CREATE_MENU._NEW_INVOICE_",
                onClick: this.onCreateInvoiceClicked.bind(this),
                iconCssClass: this.isTileMode
                                    ? this.baseCssClassName + "__create-menu__option-icon--invoice"
                                    : this.baseCssClassName + "__create-menu__option-icon icon-hb-nx-file-invoice",
                analyticsEvent: "create invoice",
                analyticsProps: "source: create menu"
            }];


            if(this.showCreateMeeting) {
                this.options.push({
                    key: this.Enums.createNew.meeting,
                    order: 0,
                    translationKey: "MAIN_NAV.CREATE_MENU._SCHEDULE_",
                    onClick: this.onScheduleMeetingClicked.bind(this),
                    iconCssClass: this.baseCssClassName + "__create-menu__option-icon icon-hb-nx-calendar",
                    analyticsEvent: "create meeting",
                    analyticsProps: "source: create menu"
                });
            }

        }

        var CreateNewPanelController = Class(Controllers.BaseController, {
            constructor: CreateNewPanelControllerConstructor,

            itemClickProxy: function itemClickProxy(currOption) {

                if (this.currUser.hasTrialExpiredDueToNoPayment()) {
                    return this.ModalService.openTrialExpiringModal(false);
                }

                if (this.onBeforeItemClick && angular.isFunction(this.onBeforeItemClick) && currOption) {
                    this.onBeforeItemClick({itemType: currOption.key});
                }

                if (currOption) {
                    currOption.onClick();
                }
            },

            createEvent: function createEvent() {
                this.EventService.createEventCommand();
            },

            onCreateClientClicked: function onCreateClientClicked() {
                // for desktop users, we show the upload clients csv modal
                // for the first time they click to add a new client
                if(this.isMobile) {
                    this._openAddClientModal();
                    return;
                }

                // TODO ALON - The brief says to open only for new subscribers. For now, we will open to all subscribers.
                var shouldShowModal = false;
                // if(true) {
                if(this.currUser.companyHasSubscription() || this.currUser.companyHasFreeSubscription()) {
                    var uploadClientsCSVModalSeen = this.UiPersistenceService.getUiPersistence(
                        this.UiPersistenceService.keys.uploadClientsCSV, {seen:false}).seen;
                    if(!uploadClientsCSVModalSeen) {
                        shouldShowModal = true;
                        this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.uploadClientsCSV, {seen: true});
                    }
                }

                if(shouldShowModal) {
                    this.ModalService.openUploadClientsModal().then(function() {

                    }).catch(function(reason) {

                        // if we got here it means the user didn't choose
                        // to upload a csv
                        if(reason === 'addClient') {

                            this.$timeout(function () {
                                this._openAddClientModal();
                            }.bind(this), 300);

                        } else if(reason === 'syncGoogleContact') {
                            this.UserService.goToContactsAndSyncGoogle();
                        }
                    }.bind(this));
                } else {
                    this._openAddClientModal();
                }
            },

            _openAddClientModal: function _openAddClientModal() {
                this.ModalService.openAddWorkspaceParticipantModal().then(function(resp) {
                    this.WorkspaceService.gotoWorkspace(resp.workspaceId, resp.projectId, {fromTopNavMenu: true});
                }.bind(this));
            },

            onCreateInvoiceClicked: function onCreateInvoiceClicked() {
                this.ModalService.openStartFromFileWizardModal({
                    type: this.Enums.createNew.invoice
                });
            },

            onScheduleMeetingClicked: function onScheduleMeetingClicked() {
                var meetingProps = {
                    isCreateMeeting: true,
                    allDay: true
                };

                if (this.NavigationService.isRouteActive(this.AppStates.root_core_navigation_calendar)) {
                    this.$rootScope.$broadcast('handle-schedule-meeting', meetingProps);
                } else {
                    this.ModalService.openCalendarMeetingModal(meetingProps).then(function() {

                        // if on mobile, should go back to the state we came from
                        if(this.isMobile) {
                            this.NavigationService.goHistoryBack();
                        }

                    }.bind(this));
                }
            }
        });

        return {
            scope: {
                baseCssClassName: '@',
                isMobile: '=',
                isTileMode: '<?',
                onBeforeItemClick: '&?',
                onBeforeCreateInvoiceClick: '&?',
                showCreateMeeting: '<?'
            },
            templateUrl: 'angular/app/modules/common/ui_components/create_new_panel/create_new_panel_template.html',
            controller: CreateNewPanelController,
            controllerAs: 'createNewPanelVm',
            bindToController: true
        };
    };


}());
